import { BaseError, LoggableError, mergeLogOptions } from '../../../../../shared/helpers/errors';
import { SafeLogErrorOptions } from '../../../../../shared/helpers/log-error';
import { GeneralErrorReason } from '../constants';

export class RoomAgentError extends BaseError {
    static from(error: unknown, loggerFields: SafeLogErrorOptions) {
        if (RoomAgentError.is(error)) {
            return error;
        }

        if (LoggableError.is(error)) {
            return new RoomAgentError(
                GeneralErrorReason.UNKNOWN_ERROR,
                error.message,
                mergeLogOptions(error.loggerFields, loggerFields),
                error.stack
            );
        }

        if (error instanceof Error) {
            return new RoomAgentError(GeneralErrorReason.UNKNOWN_ERROR, error.message, loggerFields, error.stack);
        }

        return new RoomAgentError(
            GeneralErrorReason.UNKNOWN_ERROR,
            typeof error === 'string' ? error : undefined,
            loggerFields
        );
    }

    constructor(
        public reason: string,
        public description: Maybe<string>,
        loggerFields: SafeLogErrorOptions,
        stack?: string
    ) {
        super(
            'Room agent error',
            mergeLogOptions(loggerFields, {
                additional: {
                    reason,
                    description,
                },
            }),
            stack
        );

        Object.setPrototypeOf(this, RoomAgentError.prototype);
    }
}
